
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/icc-rankings/women",
      function () {
        return require("private-next-pages/icc-rankings/women/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/icc-rankings/women"])
      });
    }
  